var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_647_1675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2868 0.751221H2.71445C1.21739 0.751221 0 1.96821 0 3.46704V20.5362C0 22.0332 1.21739 23.2489 2.71445 23.2489H21.2868C22.7838 23.2489 23.9999 22.0332 23.9999 20.5362V3.46704C24 1.96821 22.7839 0.751221 21.2868 0.751221ZM15.5196 4.79016C16.9673 4.79016 18.1414 5.96433 18.1414 7.41198C18.1414 8.85963 16.9673 10.0338 15.5196 10.0338C14.0715 10.0338 12.8978 8.85963 12.8978 7.41198C12.8978 5.96433 14.0715 4.79016 15.5196 4.79016ZM20.4356 20.7398H11.9998H3.9398C3.21569 20.7398 2.89321 20.2159 3.21963 19.5695L7.71916 10.6574C8.04518 10.0111 8.66653 9.95346 9.10655 10.5285L13.631 16.4412C14.071 17.0162 14.8401 17.0652 15.3491 16.5499L16.456 15.4291C16.9646 14.9139 17.714 14.9777 18.1291 15.5707L20.9953 19.6647C21.4096 20.2586 21.1597 20.7398 20.4356 20.7398Z",
    fill: "#4F565E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_647_1675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessLogo);
export default __webpack_public_path__ + "static/media/business_logo.260dd785447f990f8f796c2089bae8d5.svg";
export { ForwardRef as ReactComponent };